(() => {
  if (customElements.get('ziqing-review-status')) return;
  customElements.define('ziqing-review-status', class extends HTMLElement {
    connectedCallback() {
      this.widget = this.querySelector('.jdgm-review-widget');
      this.fallback = this.querySelector('[data-review-fallback]');
      if (!this.widget || !this.fallback) return;
      this.check = () => {
        const content = this.widget.querySelector('.jdgm-rev-widg');
        const heading = content?.querySelector('.jdgm-rev-widg__title');
        const ready = !!(heading?.textContent.trim() && heading.getClientRects().length &&
          getComputedStyle(heading).visibility !== 'hidden' &&
          getComputedStyle(content).display !== 'none' && content.getBoundingClientRect().height > 60);
        this.fallback.hidden = ready;
        if (ready) clearTimeout(this.timer);
      };
      this.observer = new MutationObserver(this.check);
      this.observer.observe(this.widget, {childList: true, subtree: true, attributes: true});
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.check);
        this.resizeObserver.observe(this.widget);
      }
      this.timer = setTimeout(() => {
        const status = this.querySelector('[data-review-status]');
        if (!this.fallback.hidden && status) status.textContent = status.dataset.reviewSlow;
        this.check();
      }, 12000);
      this.check();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      clearTimeout(this.timer);
    }
  });
})();
